export default "__VITE_ASSET__RD2aUXYt__"